module.exports = __webpack_public_path__ + "img/kayak001_bad.568af381.jpg";